<script setup>
import { ref } from "vue";
import ArchiveViewOrganism from "/src/components/organisms/ArchiveViewOrganism.vue";
// stripe削除（ログイン不要のため）
import { useRoute } from "vue-router";
import db from "../main.js"; //追加
import {
  doc,
  onSnapshot,
  query,
  collection,
  getDocs,
  orderBy,
  limit,
  getDoc,
  where,
  Timestamp,
} from "firebase/firestore";
// Firebase Functions削除（ログイン不要のため）

// ログイン不要のためuser propを削除
// const router = useRouter();
const showmessage = ref([]);
// showranking削除（使用しないため）

const route = useRoute();
const event_id = ref(route.query.event_id);
const live_id = ref(route.query.live_id);
// isLoadingforcredit削除（ログイン不要のため）
//メッセージを開いた時刻
// let siteOpenTime = new Date(); // JavaScriptのDateオブジェクト

// Timestampオブジェクトに変換
// let MessageTime = Timestamp.fromDate(livestartimejs.value);

// const q = query(
//   collection(db, "Goods_automessages", event_id.value, "automessages"),
//   orderBy("created_at", "asc"),
//   where("created_at", ">=", MessageTime) //where条件を追加
// );

// onSnapshot(q, (querySnapshot) => {
//   const nameshot = [];
//   querySnapshot.docChanges().forEach((change) => {
//     if (change.type === "added") {
//       const setmessage = change.doc.data();
//       showmessage.value.push(setmessage);
//     }
//     if (change.type === "modified") {
//       console.log("変更");
//     }
//     if (change.type === "removed") {
//       console.log("削除");
//     }
//   });
//   console.log(nameshot);
//   // showmessage.value = nameshot;
//   // console.log(showmessage.value);
// });

////videoのURL用とライブ開始時間を取得
// sendmessage削除（使用しないため）
const videourl = ref(null);
const videourlforondemand = ref(null);
const livestarttime = ref(null);
const livestartimejs = ref(null);
const MessageTime = ref(null);
const getvideurl = async () => {
  const docRef = doc(db, "Goods_liveshedule", live_id.value);
  const docSnap = await getDoc(docRef);
  videourl.value = docSnap.data().archive_videourl;
  videourlforondemand.value =
    process.env.VUE_APP_CLOUDFLARE_SUBDOMAIN +
    docSnap.data().videouid +
    "/manifest/video.m3u8?protocol=llhls";
  livestarttime.value = docSnap.data().livedate.start;
  livestartimejs.value = livestarttime.value.toDate();

  console.log("livestarttime: " + livestarttime.value);
  console.log("livestartimejs: " + livestartimejs.value);
  console.log("videourlforondemand: " + videourlforondemand.value);
  // Timestampオブジェクトに変換
  MessageTime.value = Timestamp.fromDate(livestartimejs.value);

  const q = query(
    collection(db, "Goods_automessages", event_id.value, "automessages"),
    orderBy("created_at", "asc"),
    where("created_at", ">=", MessageTime.value) //where条件を追加
  );

  // 一度だけクエリを実行
  getDocs(q)
    .then((querySnapshot) => {
      const nameshot = [];
      querySnapshot.forEach((doc) => {
        const setmessage = doc.data();
        showmessage.value.push(setmessage);
      });
      console.log(nameshot);
      console.log(showmessage.value);
    })
    .catch((error) => {
      console.error("Error getting documents: ", error);
    });
};
getvideurl();

//お茶代読み込み

const ochaPrice = ref(0);
const getochaprice = async () => {
  onSnapshot(doc(db, "Goods_products", event_id.value), (doc) => {
    ochaPrice.value = doc.data().ocha_price;
  });
};
getochaprice();

// ユーザー依存のデータ取得を削除（ログイン不要のため）

// 購入機能は削除（ログイン不要のため）

// レガシーコード削除

// キャリア決裁購入機能削除

// 商品選択機能削除（ログイン不要のため）

// トレカ選択機能削除（ログイン不要のため）

// 商品購入レガシーコード削除

// Paidy決済機能削除
// 商品購入機能削除（ログイン不要のため）

// コメント機能削除（ログイン不要のため）

//point呼び出し
const rankingarray = ref([]);
// const rankingno1 = ref(null);
// const rankingno2 = ref(null);
// const rankingno3 = ref(null);
const getpoint = async () => {
  const querypoint = query(
    collection(db, "Goods_ranking", event_id.value, "ranking"),
    limit(3),
    orderBy("points", "desc")
  );
  // , where("capital", "==", true));
  onSnapshot(querypoint, (querySnapshot) => {
    rankingarray.value = [];

    if (querySnapshot.empty) {
      const rankingarray = [];
      return rankingarray;
    }

    // const querySnapshot = await onSnapshot(querypoint);
    querySnapshot.forEach((doc) => {
      const setranking = doc.data();
      rankingarray.value.push(setranking);
    });
  });
};
getpoint();

//vtuberのグッズの商品データを取得
const goodsData = ref([]);
const getProductsData = async () => {
  const querySnapshot = await getDocs(collection(db, "Goods_products", event_id.value, "products"));
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    goodsData.value.push(data);
  });
};

getProductsData();

// const sendaddress = async (postcode, address1, address2, name, phoneno) => {
//   //refを消す
//   const postcodeno = postcode.value;
//   const address1no = address1.value;
//   const address2no = address2.value;
//   const nameno = name.value;
//   const phonenono = phoneno.value;
//   const functions = getFunctions();
//   functions.region = "asia-northeast1"; // これを追加
//   const addMessage = httpsCallable(functions, "Goods_Addaddress");
//   await addMessage({
//     postcode: postcodeno,
//     address1: address1no,
//     address2: address2no,
//     name: nameno,
//     phoneno: phonenono,
//   }).then(async (res) => {
//     console.log(res);
//     await getAddressData();
//     // dialog.value = false;
//   });
// };
// 送料計算機能削除（ログイン不要のため）

//vendor情報取得及び販売期間中かどうかの判定
const vendorsData = ref();
const vendorname_ja = ref();
const unitPrice = ref();
const isSelling = ref(true);
let checkInterval = null;
const suppercommenttype = ref();
const vendorData = async () => {
  const docRef = doc(db, "Goods_products", event_id.value);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    vendorsData.value = docSnap.data();
    vendorname_ja.value = docSnap.data().vendor_ja;
    unitPrice.value = docSnap.data().price;
    //本来は子のコンポーネントでvendorsDataから取得すべき
    suppercommenttype.value = docSnap.data().supercommenttype;
    const endTimestamp = docSnap.data().eventdate?.end;
    if (endTimestamp) {
      const endDate = endTimestamp.toDate(); // FirebaseのタイムスタンプをJavaScriptのDateオブジェクトに変換
      const currentDate = new Date();

      if (currentDate > endDate) {
        console.log("販売終了");
        console.log(currentDate);
        console.log(endDate);
        isSelling.value = false;
        console.log(isSelling.value);
      } else {
        startCheckingEndDate(endDate);
      }
    }
  } else {
    // docSnap.data() will be undefined in this case
  }
};
vendorData();

const startCheckingEndDate = (endDate) => {
  // 1分ごとにチェック
  checkInterval = setInterval(() => {
    const currentDate = new Date();
    if (currentDate > endDate) {
      isSelling.value = false;
      clearInterval(checkInterval);
    }
  }, 60000); // 60000ミリ秒 = 1分
};

// デフォルトアドレス・決済方法判定削除（ログイン不要のため）

// 商品キャリア決裁購入機能削除
// キャリアペイメント後のダイアログ機能削除

//streaming中かどうかを判定する。streaming中でなければリダイレクト
// const streamingflag = ref(true);

// onSnapshot(doc(db, "Goods_products", event_id.value), (doc) => {
//   streamingflag.value = doc.data().nowstreaming;
//   if (streamingflag.value === false) {
//     router.push(`itemlist_v?event_id=${event_id.value}`);
//   } else {
//     console.log("streaming");
//   }
// });
// スーパーコメント完了状態変更機能削除
</script>
<template>
  <ArchiveViewOrganism
    :showmessage="showmessage"
    :showranking="[]"
    :videourl="videourl"
    :videourlforondemand="videourlforondemand"
    :rankingarray="rankingarray"
    :goodsData="goodsData"
    :vendorsData="vendorsData"
    :isSelling="isSelling"
    :ochaPrice="ochaPrice"
    :suppercommenttype="suppercommenttype"
    :MessageTime="MessageTime"
    :vendorname_ja="vendorname_ja"
  />
</template>

<style scoped>
.reset {
  width: 500px;
  height: 3000px;
}
</style>

<!-- <template>
  <div>
    <video
      ref="videoPlayer"
      controls
      muted
      @canplaythrough="onCanPlayThrough"
      @error="onError"
    ></video>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const videoPlayer = ref(null);

const loadVideo = async () => {
  try {
    const url =
      "https://storage.googleapis.com/rf-dev-sukisuki-ls.appspot.com/2024-06-12%2003-35-27.mp4";
    videoPlayer.value.src = url;
    videoPlayer.value.load(); // 動画の読み込みを開始
  } catch (error) {
    console.error("Failed to load video URL:", error);
  }
};

const onCanPlayThrough = () => {
  console.log("Video can play through without interruption");
  videoPlayer.value.play();
};

const onError = (event) => {
  console.error("Failed to load video:", event);
};

onMounted(loadVideo);
</script>

<style scoped>
video {
  width: 100%;
  height: auto;
}
</style> -->
